import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-sage/20 last:border-0" data-id="element-25">
      <button onClick={onClick} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-26">
        <span className="text-lg md:text-xl font-serif text-brown group-hover:text-sage transition-colors duration-300" data-id="element-27">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="ml-4 flex-shrink-0 text-sage" data-id="element-28">
          <ChevronDown className="w-6 h-6" data-id="element-29" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-30">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-31">
            <p className="pb-6 text-brown-light leading-relaxed text-lg" data-id="element-32">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo lo recibo?',
    a: 'Después del pago, recibís el PDF para descargar (y los bonus).'
  }, {
    q: '¿Se paga por Mercado Pago?',
    a: 'Sí. Mercado Pago.'
  }, {
    q: '¿Tengo que cocinar raro o comprar cosas caras?',
    a: 'No. Es comida simple y súper argentina. Si querés, podés hacerlo más económico repitiendo opciones.'
  }, {
    q: '¿Es sin gluten / sin lácteos?',
    a: 'No es un plan de restricción extrema. Es “bajo irritantes” y flexible. Si algo te cae mal, usás la tabla de sustituciones.'
  }, {
    q: '¿En cuánto tiempo veo cambios?',
    a: 'Depende de tu cuerpo y tus hábitos. La idea es que en 7 días notes más orden y menos inflamación, sin prometer milagros.'
  }, {
    q: '¿Y si un día me salgo?',
    a: 'Volvés en la próxima comida. Esa es la regla.'
  }];
  return <section className="py-24 px-4 bg-cream-dark" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <FadeIn className="text-center mb-16" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-serif text-brown" data-id="element-36">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="bg-white px-6 md:px-10 py-4 rounded-3xl shadow-sm border border-sage/10" data-id="element-37">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-38" />)}
        </FadeIn>
      </div>
    </section>;
}